import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function KerbIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 37 36"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4897_18205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41748 12.75H19.4175M19.4175 12.75L6.66748 36.75M19.4175 12.75L20.9175 19.5L12.6675 36.75",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9044 4.74835C20.0425 3.91858 20.9781 3.46834 21.7124 3.8784L21.8677 3.98028L25.1406 6.48731L28.8589 4.31094L29.0225 4.22874C29.8539 3.89018 30.7949 4.55241 30.7067 5.48897L30.3213 9.57709L33.6166 11.7098C34.4681 12.2615 34.3245 13.5491 33.3723 13.8994L30.3338 15.0153L30.4151 19.1438C30.4327 20.0425 29.5128 20.6568 28.6896 20.2959L24.5404 18.4769C24.0958 18.2816 23.8936 17.7619 24.0887 17.3172C24.2839 16.8727 24.8027 16.6707 25.2474 16.8656L28.6395 18.3537L28.5625 14.4226L28.5506 13.7972L31.7735 12.6128L28.9179 10.7642L28.4702 10.4748L28.5203 9.94331L28.8589 6.34911L25.5209 8.30342L25.011 8.60372L24.5418 8.24293L21.6235 6.00845L21.5462 9.62312C21.5357 10.1087 21.1329 10.4945 20.6473 10.4841C20.1619 10.4735 19.7763 10.0717 19.7866 9.58623L19.8879 4.93112L19.9044 4.74835Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4897_18205"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: "36",
    transform: "translate(0.66748)",
    width: "36"
  }))));
}